import { ClientLogger } from 'bernie-client';
import { STORE_EVENTS } from 'stores/events/store-events';
const logger = ClientLogger.getLoggerWithIdentifier('pwa.adapter.bex-api.search-results');
export const mapOmnitureData = analytics => {
  if (Array.isArray(analytics) && analytics.length > 0 && analytics[0]) {
    return analytics[0];
  }
  logger.logEvent(STORE_EVENTS.BEX_API_SEARCH_RESULTS_OMNITURE_PARSE_ERROR, 'Failed to parse omniture data');
  return null;
};